// i18n area 'auth' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua): tradotto DALL'ITALIANO, che è la lingua SORGENTE (regola
// ratificata 2026-08-03); gli anglicismi del sorgente si TRASLANO secondo l'uso
// vivo islandese (lykilorð, innskráning, tveggja þátta auðkenning); realm,
// directory e break-glass restano invariati (termini di contract).
// Sidecar anti-stantie: ../meta/auth.is-IS.meta.json.
import type { enUS } from './auth'

export const isIS: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Skráðu þig inn á aðganginn þinn',
    username: 'Notandanafn',
    usernamePlaceholder: 'Sláðu inn notandanafnið',
    usernameHint: 'Notaðu notandi@lén til að skrá þig inn á directory-realm',
    continue: 'Áfram',
    changeUser: 'Ekki þú?',
    password: 'Lykilorð',
    forgotPassword: 'Gleymt lykilorð?',
    submit: 'Skrá inn',
    otp: 'Einnota kóði',
    otpSubtitle: 'Sláðu inn kóðann úr auðkenningarappinu',
    otpHint: 'Sex tölustafir úr auðkenningarappinu, eða einn af endurheimtarkóðunum þínum',
    otpSubmit: 'Staðfesta',
    invalidCredentials: 'Rangt notandanafn eða lykilorð',
    tooManyAttempts: 'Of margar tilraunir — bíddu augnablik og reyndu aftur',
    realmUnavailable: 'Realmið getur ekki sannreynt aðgangsupplýsingar í augnablikinu — ekki næst í gagnageymslu klasans. Skráðu þig inn sem staðbundinn notandi (break-glass).',
    genericError: 'Innskráning mistókst — næst samband við TVirt-bakendann?'
  },
  user: {
    logout: 'Skrá út',
    password: {
      menu: 'Breyta lykilorði',
      title: 'Breyttu lykilorðinu þínu',
      current: 'Núverandi lykilorð',
      new: 'Nýtt lykilorð',
      confirm: 'Staðfestu nýja lykilorðið',
      mismatch: 'Lykilorðin stemma ekki',
      error: 'Ekki tókst að breyta lykilorðinu',
      forcedTitle: 'Breyttu lykilorðinu til að halda áfram',
      forcedHint: 'Þetta lykilorð var sett af kerfisstjóra og þarf að skipta því út áður en þú ferð inn.',
      forcedSubmit: 'Breyta og fara inn'
    },
    mfa: {
      title: 'Tveggja þátta auðkenning',
      subtitle: 'Beðið er um annan þátt við hverja innskráningu',
      loadError: 'Ekki tókst að sækja stöðu annars þáttar',
      enrolled: 'Virkur',
      notEnrolled: 'Ekki virkur',
      enrolledAt: 'Virkjaður þann',
      codesRemaining: 'Endurheimtarkóðar eftir',
      requiredHint:
        'Kerfisstjóri krefst annars þáttar á þessum aðgangi: settu hann upp núna — þangað til geturðu skráð þig inn, en lítið annað.',
      enroll: 'Setja upp',
      enrollTitle: 'Setja upp tveggja þátta auðkenningu',
      enrollHint: 'Skannaðu þennan kóða með auðkenningarappinu og sláðu síðan inn kóðann sem það sýnir til að staðfesta.',
      secretHint: 'Nærðu ekki að skanna hann? Sláðu þetta leyndarmál inn í appið í staðinn:',
      code: 'Kóði úr appinu',
      confirm: 'Staðfesta',
      startError: 'Ekki tókst að hefja uppsetninguna',
      confirmError: 'Ekki tókst að staðfesta uppsetninguna',
      codesTitle: 'Endurheimtarkóðarnir þínir',
      codesWarning:
        'Þessir kóðar eru aðeins sýndir einu sinni. Vistaðu þá núna: hver þeirra skráir þig inn þegar auðkenningarappið er ekki tiltækt, og hver gildir aðeins einu sinni.',
      codesAck: 'Ég hef vistað endurheimtarkóðana',
      codesDone: 'Lokið',
      copy: 'Afrita',
      copied: 'Afritað',
      download: 'Sækja',
      regenerate: 'Nýir endurheimtarkóðar',
      regenerateTitle: 'Endurgera endurheimtarkóðana',
      regenerateHint: 'Allir kóðar sem gefnir hafa verið út hætta að virka um leið og nýja settið er búið til.',
      regenerateConfirm: 'Endurgera',
      regenerateError: 'Ekki tókst að endurgera endurheimtarkóðana',
      remove: 'Fjarlægja',
      removeTitle: 'Fjarlægja annan þáttinn',
      removeConfirm: 'Fjarlægja',
      removeHint: 'Aðgangurinn fer aftur í lykilorð eingöngu. Þú getur sett upp annan þátt aftur hvenær sem er.',
      removeRequiredHint:
        'Kerfisstjóri krefst annars þáttar á þessum aðgangi, svo þjónninn mun hafna því að fjarlægja hann — biddu hann fyrst um að aflétta kröfunni.',
      removeError: 'Ekki tókst að fjarlægja annan þáttinn'
    },
    profile: {
      menu: 'Fara á prófílinn minn',
      sessions: 'Virkar setur',
      sessionsHint: 'Opnu seturnar þínar á þessum hnút',
      sessionsEmpty: 'Engar virkar setur',
      sessionCreated: 'Innskráning',
      sessionExpires: 'Rennur út',
      revoke: 'Afturkalla setu',
      revokeError: 'Ekki tókst að afturkalla setuna',
      loadError: 'Ekki tókst að sækja seturnar'
    }
  }
}
